import {pressItemAppear} from '../lib/animations-new';
import LazyIframeComponent from './lazy-iframe';

export default class PopupNew {
  static CLASSES = {
    POPUP: 'popup-new',
    POPUP_ACTIVE: 'popup-new--active',
    MODAL_ACTIVE: 'popup-new-modal--active',
    VIDEO_TEMPLATE: 'popup-new-modal__video--template',
    PREVIEW_VIDEO: 'popup-new-modal__relative-preview--video',
    HIDDEN: 'hidden'
  };

  static TYPES = {
    IMAGE: 'image',
    VIDEO: 'video'
  };

  constructor(data) {
    this.DATA = data;

    this.$POPUP = document.querySelector('.popup-new');
    this.$MODAL = document.querySelector('.popup-new-modal');
    this.$MODAL_INFO = document.querySelector('.popup-new-modal__info');
    this.$MODAL_CLOSE = document.querySelector('.popup-new-modal-close');
    this.$MODAL_ARROW_PREV = document.querySelector('.popup-new-modal-arrow--prev');
    this.$MODAL_ARROW_NEXT = document.querySelector('.popup-new-modal-arrow--next');
    this.$MODAL_IMAGE = document.querySelector('.popup-new-modal__image');
    this.$MODAL_RELATIVE = document.querySelector('.popup-new-modal__relative');
    this.$MODAL_RELATIVE_PREVIEW = document.querySelector('.popup-new-modal__relative-preview');
    this.$MODAL_VIDEO_TEMPLATE = document.querySelector(`.${PopupNew.CLASSES.VIDEO_TEMPLATE}`);
    this.$MODAL_TITLE = document.querySelector('.popup-new-modal__info-title');
    this.$MODAL_TEXT = document.querySelector('.popup-new-modal__info-text');
    this.$MODAL_DOWNLOAD = document.querySelector('.popup-new-modal__info-download');

    this.MAX_RELATIVE_COUNT = 7;

    this.initEvents();
  }

  setIndex = (index) => {
    this.INDEX = index;
  };

  setData = (data) => {
    this.DATA = data;
  };

  closePopup = () => {
    document.body.style.overflow = 'auto';

    this.$MODAL.classList.remove(PopupNew.CLASSES.MODAL_ACTIVE);
    this.$POPUP.classList.remove(PopupNew.CLASSES.POPUP_ACTIVE);

    this.handleUsedVideo();
  };

  openPopupHandler = (data) => {
    if (!data) return;

    document.body.style.overflow = 'hidden';

    this.createPopup(data);
  };

  initItems = () => {
    this.DATA.forEach((item) => {
      let {clickItem, ...rest} = item;
      let cleanItem = clickItem.cloneNode(true);

      cleanItem.addEventListener('click', () => this.openPopupHandler({...rest}));
      clickItem.replaceWith(cleanItem);
    });

    pressItemAppear();
  };

  initEvents = () => {
    this.initItems();

    this.$MODAL_CLOSE?.addEventListener('click', this.closePopup);
    this.$MODAL_ARROW_PREV?.addEventListener('click', this.prevImage);
    this.$MODAL_ARROW_NEXT?.addEventListener('click', this.nextImage);
  };

  prevImage = () => {
    let closestLowerIndex = null;
    let farthestHigherIndex = null;

    for (let i = 0; i < this.DATA.length; i++) {
      if (this.DATA[i].type === this.DATA[this.INDEX].type) {
        if (i < this.INDEX) {
          closestLowerIndex = i;
        } else if (i > this.INDEX) {
          farthestHigherIndex = i;
        }
      }
    }

    if (closestLowerIndex !== null || farthestHigherIndex !== null) {
      if (closestLowerIndex !== null) {
        this.setIndex(closestLowerIndex);
      } else {
        this.setIndex(farthestHigherIndex);
      }

      this.createPopup(this.DATA[this.INDEX]);
    }
  };

  nextImage = () => {
    let closestHigherIndex = null;
    let farthestLowerIndex = null;

    for (let i = this.DATA.length - 1; i >= 0; i--) {
      if (this.DATA[i].type === this.DATA[this.INDEX].type) {
        if (i > this.INDEX) {
          closestHigherIndex = i;
        } else if (i < this.INDEX) {
          farthestLowerIndex = i;
        }
      }
    }

    if (closestHigherIndex !== null || farthestLowerIndex !== null) {
      if (closestHigherIndex !== null) {
        this.setIndex(closestHigherIndex);
      } else {
        this.setIndex(farthestLowerIndex);
      }

      this.createPopup(this.DATA[this.INDEX]);
    }
  };

  hideArrowsIfNecessary = () => {
    let otherElementExists = false;

    for (let i = 0; i < this.DATA.length; i++) {
      if (this.DATA[i].type === this.DATA[this.INDEX].type && i !== this.INDEX) {
        otherElementExists = true;
      }
    }

    if (otherElementExists) {
      this.$MODAL_ARROW_NEXT.classList.remove(PopupNew.CLASSES.HIDDEN);
      this.$MODAL_ARROW_PREV.classList.remove(PopupNew.CLASSES.HIDDEN);
    } else {
      this.$MODAL_ARROW_NEXT.classList.add(PopupNew.CLASSES.HIDDEN);
      this.$MODAL_ARROW_PREV.classList.add(PopupNew.CLASSES.HIDDEN);
    }
  };

  hideInfoIfNecessary = (data) => {
    if (!(data.title || data.text)) {
      this.$MODAL_INFO.classList.add(PopupNew.CLASSES.HIDDEN);
    } else {
      this.$MODAL_INFO.classList.remove(PopupNew.CLASSES.HIDDEN);
    }
  };

  handleUsedVideo = () => {
    const videos = this.$MODAL.querySelectorAll('.popup-new-modal__video');

    if (videos.length > 1) {
      videos[0].remove();
    }
  };

  handleDataType = (data) => {
    if (data.type === PopupNew.TYPES.VIDEO || data.video) {
      const video = this.$MODAL_VIDEO_TEMPLATE.cloneNode(true);

      video.dataset.lazyIframe = JSON.stringify({src: data.video});
      video.querySelector('img').setAttribute('src', data.image);
      video.classList.remove(PopupNew.CLASSES.VIDEO_TEMPLATE);

      this.$MODAL_IMAGE.classList.add(PopupNew.CLASSES.HIDDEN);
      this.$MODAL.insertBefore(video, this.$MODAL_VIDEO_TEMPLATE);

      LazyIframeComponent.initAll();
    } else {
      this.$MODAL_IMAGE.setAttribute('src', data.image);
      this.$MODAL_IMAGE.classList.remove(PopupNew.CLASSES.HIDDEN);
    }
  };

  createPopup = (data) => {
    this.handleUsedVideo();
    this.setIndex(data.index);
    this.handleDataType(data);

    const parsedRelative = JSON.parse(data.relative || '[]');

    if (parsedRelative?.length) {
      this.$MODAL_RELATIVE.replaceChildren();

      for (let i = 0; i < this.MAX_RELATIVE_COUNT; i++) {
        if (i >= parsedRelative.length) break;

        const preview = this.$MODAL_RELATIVE_PREVIEW.cloneNode(true);
        const item = parsedRelative[i];

        preview.querySelector('img').setAttribute('src', item.image);
        preview.addEventListener('click', () => this.handleRelativeClick(item));

        if (item.video) {
          preview.classList.add(PopupNew.CLASSES.PREVIEW_VIDEO);
        }

        preview.classList.remove(PopupNew.CLASSES.HIDDEN);

        this.$MODAL_RELATIVE.append(preview);
      }

      this.$MODAL_RELATIVE.classList.remove(PopupNew.CLASSES.HIDDEN);
    } else {
      this.$MODAL_RELATIVE.classList.add(PopupNew.CLASSES.HIDDEN);
    }

    this.handleMediaInfo(data);
    this.hideArrowsIfNecessary();

    this.$POPUP.classList.add(PopupNew.CLASSES.POPUP_ACTIVE);
    this.$MODAL.classList.add(PopupNew.CLASSES.MODAL_ACTIVE);
  };

  handleMediaInfo = (data) => {
    this.$MODAL_TITLE.textContent = data.title || '';
    this.$MODAL_TEXT.textContent = data.text || '';

    if (data.src) {
      this.$MODAL_DOWNLOAD.setAttribute('href', data.src);
      this.$MODAL_DOWNLOAD.classList.remove(PopupNew.CLASSES.HIDDEN);
    } else {
      this.$MODAL_DOWNLOAD.classList.add(PopupNew.CLASSES.HIDDEN);
    }

    this.hideInfoIfNecessary(data);
  };

  handleRelativeClick = (data) => {
    this.handleUsedVideo();
    this.handleDataType(data);
    this.handleMediaInfo(data);
  };
}
